
import { EnumImpostazioniActions } from './impostazioni_actions';
import update from 'immutability-helper';
const initialState = {
    info: null,
    lastSchemaDati: null,
    listSchemaDati: [],
    listParametriSistema: [],
    listI18n: [],
    i18n: {
        listApLang: [],
        code: null
    }
}

const impostazioni = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }
    
    switch (action.type) {

        case EnumImpostazioniActions.INFO:
            return Object.assign({}, state, { info: action.dati, })
        case EnumImpostazioniActions.LAST_SCHEMA_DATI:
            return Object.assign({}, state, { lastSchemaDati: action.dati, })
        case EnumImpostazioniActions.IMPOSTAZIONI_SCHEMA_DATI:
            return Object.assign({}, state, { listSchemaDati: action.dati, })
        case EnumImpostazioniActions.IMPOSTAZIONI_PARAMETRI:
            return Object.assign({}, state, { listParametriSistema: action.dati, })
        case EnumImpostazioniActions.IMPOSTAZIONI_I18N:
            return Object.assign({}, state, { listI18n: action.dati, })
        case EnumImpostazioniActions.IMPOSTAZIONI_I18N_DETAILS:
            return Object.assign({}, state, { listI18n: action.dati, })
        case EnumImpostazioniActions.NEWI18N:
            return update(state, { i18n: { $merge: action.dato } });
        case EnumImpostazioniActions.UPDATE_I18N_LIST:
            return update(state, action.dato);
        //     return update(state, { i18n: action.i18n });
        // // Object.assign({}, state, { i18n: action.dato, })
        // case EnumImpostazioniActions.IMPOSTAZIONI_HANDLE_CHANGE_CODICE:
        //     return Object.assign({}, state, { i18n: action.dati, })
        default:
            return state;
    }
}

export default impostazioni;